
const loginSchema = () => {
  return {
    mobile: {
      presence: {
        allowEmpty: false,
        message: '^شماره تلفن همراه خود را وارد کنید.'
      },
      format: {
        pattern: "^(09)\\d{9}$",
        message: '^شماره تلفن وارد شده اشتباه است.'
      }
    },
  }
}

export default loginSchema
